var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',_vm._b({attrs:{"value":_vm.value,"placeholder":_vm.computedPlaceholder},on:{"change":_vm.onChange}},'el-select',_vm.$attrs,false),_vm._l((_vm.semesterList),function(item){return _c('el-option',{key:item.PK_Semester_ID,attrs:{"label":item.SMT_Code,"value":item.PK_Semester_ID}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }